import { render, staticRenderFns } from "./UpdateStaffModal.vue?vue&type=template&id=7678ad2c&"
import script from "./UpdateStaffModal.vue?vue&type=script&lang=js&"
export * from "./UpdateStaffModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateStaffModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports